import { render, staticRenderFns } from "./RevSummary.vue?vue&type=template&id=6131c886"
import script from "./RevSummary.vue?vue&type=script&lang=js"
export * from "./RevSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports